import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_AMORTIZATIONS}/payments/list-of-payments-pending`

export default (queryParams = {}) =>
  http.get(`${api}`, { params: { ...queryParams } })
